<template>
    <div>
        <Loader v-if="isLoading"></Loader>
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Tombamento de planilha</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><router-link to="/ListaContratacoes">Contratações</router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>Tombamento de planilha</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Tombamento de Contratação Garantia Locatícia</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo">Planilha Excel Tombamento</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="6">
                                                        <label>Garantidora</label>
                                                        <v-autocomplete v-model="selectedGarantidora" :items="DadosGarantidora" item-title="garNomeEmpresa" item-value="garId"
                                                            density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                            no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobialiarias()" return-object />
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <label>Imobiliária</label>
                                                        <v-autocomplete v-model="selectedImobiliaria" :items="ListImobiliarias" item-title="nomeConcatenado" item-value="imoId"
                                                            density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                            no-data-text="Nenhum registro encontrado" @update:model-value="SelecionarConsumidor()" return-object />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="6">
                                                        <label>Cobertura (quantidade de vezes)</label>
                                                        <v-text-field v-model.number="coberturaQtdeVezes" type="number" min="0.01" step="0.01"
                                                            density="compact" variant="outlined" placeholder="Ex.: 12" hide-details />
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="d-flex align-center">
                                                        <v-switch v-model="gerarContrato" color="#102a5a" hide-details
                                                            label="Gerar contrato após importar" />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="5">
                                                        <label for="exampleFormControlFile1">* xlsx</label>
                                                        <v-file-input v-model="selectedFile" label="Selecione o arquivo"
                                                            variant="underlined" prepend-icon="mdi-file"
                                                            accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></v-file-input>
                                                    </v-col>
                                                    <v-col cols="12" md="4" style="text-align: left;">
                                                        <button type="button" style="color:#ffffff;"
                                                            class="btn btn-warning" @click="CarregaExcelMemoria()">
                                                            Tombamento Direto Vigente
                                                        </button>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="ResultadosImportacao.length">
                                                    <v-col cols="12">
                                                        <div class="gp-import-summary">
                                                            <strong>Resultado da importação</strong>
                                                            <span>{{ progressoImportacao }}</span>
                                                        </div>
                                                        <div v-for="resultado in ResultadosImportacao" :key="resultado.linha"
                                                            :class="['gp-import-result', resultado.aviso ? 'is-warning' : (resultado.sucesso ? 'is-success' : 'is-error')]">
                                                            Linha {{ resultado.linha }} — {{ resultado.mensagem }}
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                               <v-row>
                                                <v-col cols="12">
                                                    <div v-for="(erro, i) in ListaErros" :key="i">
                                                    • {{ erro }}
                                                    </div>
                                                </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import Loader from '../../components/PageLoader.vue'
import * as XLSX from "xlsx";

export default {
    name: 'NovaContratacaoView',
    components: {
        EasyDataTable,
        moment,
        Loader
    },
    data: () => ({
        tab: null,
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
            cusid: 0
        },
        selectedFile: '',
        ListaPedidoItem: [],
        DadosGarantidora: [],
        DadosImobiliaria: [],
        //garantidoras
        selectedGarantidora: null,
        //Imobiliarias
        selectedImobiliaria: null,
        ListImobiliarias: [],
        //Imobliarias
        ListConsumidor: [],
        selectedConsumidor: null,
        NumeroPedido:'',
        ListaErros: [],
        ResultadosImportacao: [],
        progressoImportacao: '',
        isLoading: false,
        coberturaQtdeVezes: null,
        gerarContrato: false,
    }),
    methods: {
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        //garantidoras
        async BuscaImobialiarias() {
            if (this.selectedGarantidora != '' && this.selectedGarantidora != null) {
                this.selectedImobiliaria = null;
                this.ListImobiliarias = this.DadosImobiliaria.filter(x => x.imoVisivel && x.garId == this.selectedGarantidora.garId).sort((a, b) =>
                    a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                    )
                );
                this.ListImobiliarias = this.ListImobiliarias.map(item => {
                    return {
                        ...item,
                        nomeConcatenado: `${item.imoId} - ${item.imoNomeEmpresa} - ${item.imoDocumento}`
                    };
                });
            }
        },
        async SelecionarConsumidor() {
            if (this.selectedImobiliaria != '' && this.selectedImobiliaria != null) {
                this.ListConsumidor = [];
                await axios.get(`/Telas/TombamentoContratacao/GetByGarIdImoIdClientes/0/` + this.selectedImobiliaria.imoId)
                    .then(response => {
                        this.ListConsumidor = response.data.filter(x => x.cliAtivo).sort((a, b) =>
                            a.cliNomeEmpresa.localeCompare(
                                b.cliNomeEmpresa,
                                'pt',
                                { sensitivity: 'base' }
                            )
                        );
                        this.ListConsumidor = this.ListConsumidor.map(item => {
                            return {
                                ...item,
                                nomeConcatenado: `${item.cliId} - ${item.cliNomeEmpresa} - ${item.cliDocumento}`
                            };
                        });
                    });
            }
        },
        // Tombamento
        async CarregaCliente(dados) {
            this.startLoading();
             const resultado = await this.validarListaPedidoItem();

                if (!resultado.valido) {
                    // trava aqui
                    this.stopLoading();
                    return;
                }
                else{
                    this.ListaErros = [];
                }

                for (let index = 0; index < dados.length; index++) {
                    const element = dados[index];
                    var _cliente = this.ListConsumidor.filter(x=> x.cliDocumento == element.documentoCPFCNPJ);
                    var _tpdDoc =  String(element.documentoCPFCNPJ).replaceAll('.','').replaceAll('.','-').replaceAll('/','');
                    console.log('_cliente')
                    console.log(_cliente)
                    console.log('element')
                    console.log(element)
                    if (_cliente.length > 0){
                        if (_cliente[0].cliEmail != element.email){
                            var _clienteUpdate = {
                                    cliId: _cliente[0].cliId,
                                    cliVisivel: _cliente[0].cliVisivel,
                                    cliDataCadastro: _cliente[0].cliDataCadastro,
                                    cliNomeEmpresa: _cliente[0].cliNomeEmpresa,
                                    cliRazaoSocial: _cliente[0].cliRazaoSocial,
                                    tpdId: _cliente[0].tpdId,
                                    cliDocumento: _cliente[0].cliDocumento,
                                    cliTelefone: _cliente[0].cliTelefone,
                                    cliWhatsapp: _cliente[0].cliWhatsapp,
                                    cliResponsavel: _cliente[0].cliResponsavel,
                                    cliEmail: element.email,
                                    cliAtivo: _cliente[0].cliAtivo,
                                    cliDataAniversario: _cliente[0].cliDataAniversario,
                                    garId: this.selectedGarantidora.garId,
                                    imoId: this.selectedImobiliaria.imoId,
                                }
                            await axios.put(`/Telas/TombamentoContratacao/UpdateCliente`, _clienteUpdate)
                                .then(response => {
                                    if (response.data > 0) {
                                        console.log('Cliente atualizado')
                                        // console.log(_clienteUpdate)
                                    }
                                });
                            _cliente[0].cliEmail = element.email;
                        }
                    

                    this.selectedConsumidor = _cliente[0];
                        await axios.get(`/Telas/TombamentoContratacao/GetEnderecoByCli/` + _cliente[0].cliId)
                            .then(response => {
                                if (response.data.length > 0) {
                                     var _endereco1 = response.data[0];
                                     _endereco1.cleEndereco = element.endRua;
                                     _endereco1.cleNumero = element.endNumero;
                                     _endereco1.cleComplemento = element.endComplemento;
                                     _endereco1.cleCep = element.endCEP != null ? String(element.endCEP).replace(/\D/g, "") : response.data[0].cleCep;
                                     _endereco1.cleEstado = element.endEstado;
                                     _endereco1.cleCidade = element.endCidade;
                                     _endereco1.cleBairro = element.endBairro;
                                    
                                    this.CarregaPedidoVigente(element, _endereco1);
                                }
                                else{
                                var _endereco2 = {
                                        cleId: 0,
                                        grtId: 0,
                                        cdtId: 0,
                                        cleEndereco: element.endRua,
                                        cleNumero: element.endNumero,
                                        cleComplemento: element.endComplemento,
                                        cleObsEndereco: '',
                                        cleCep: element.endCEP != null ? String(element.endCEP).replace(/\D/g, "") : null,
                                        clePais: 'Brasil',
                                        cleEstado: element.endEstado,
                                        cleCidade: element.endCidade,
                                        cleBairro: element.endBairro,
                                        cliId: _cliente[0].cliId
                                    };
                                    axios.post(`/Telas/TombamentoContratacao/AddClienteEndereco`, _endereco2)
                                        .then(response => {
                                            if (response.data > 0) {
                                                _endereco2.cleId = response.data;
                                                this.CarregaPedidoVigente(element, _endereco2);
                                            }
                                        });
                                }
                            });                  
                    }
                    else{
                        let dadosCliente = {
                                cliId: 0,
                                cliVisivel: true,
                                cliDataCadastro: this.$moment().format('YYYY-MM-DD'),
                                cliNomeEmpresa: element.nome,
                                cliRazaoSocial: _tpdDoc.length > 12 ? element.nome: null,
                                tpdId: _tpdDoc.length > 12 ? 2 : 1,
                                cliDocumento: element.documentoCPFCNPJ,
                                cliTelefone: String(element.whatsapp),
                                cliWhatsapp: String(element.whatsapp),
                                cliResponsavel: _tpdDoc.length > 12 ? element.nome: null,
                                cliEmail: element.email,
                                cliAtivo: true,
                                cliDataAniversario: null,
                                garId: this.selectedGarantidora.garId,
                                imoId: this.selectedImobiliaria.imoId,
                            }
                        await axios.post(`/Telas/TombamentoContratacao/AddCliente`, dadosCliente)
                            .then(response => {
                                if (response.data > 0) {
                                dadosCliente.cliId = response.data;
                                var _endereco = {
                                        cleId: 0,
                                        grtId: 0,
                                        cdtId: 0,
                                        cleEndereco: element.endRua,
                                        cleNumero: element.endNumero,
                                        cleComplemento: element.endComplemento,
                                        cleObsEndereco: '',
                                        cleCep: element.endCEP != null ? String(element.endCEP).replace(/\D/g, "") : null,
                                        clePais: 'Brasil',
                                        cleEstado: element.endEstado,
                                        cleCidade: element.endCidade,
                                        cleBairro: element.endBairro,
                                        cliId: dadosCliente.cliId
                                    };
                                axios.post(`/Telas/TombamentoContratacao/AddClienteEndereco`, _endereco)
                                    .then(response => {
                                        if (response.data > 0) {
                                            _endereco.cleId = response.data;
                                            this.CarregaPedidoVigente(element, _endereco);
                                        }
                                    });
                                
                                }
                            });
                    }
            }
                
            this.stopLoading();    
            this.$mensagemAviso("A contratação cadastrada.")
            this.$router.push('/listacontratacoesvigentes')
        },
        async CarregaPedidoVigente (dados, _endereco){
            let _situacao = 'Aguardando Analise';
            let _pspId = 1;

            let valorTotalFinal = dados.qtdeParcelas * dados.valorParcelas;
            let valorParcelas = dados.valorParcelas;
            let qtdeParcelas = dados.qtdeParcelas;
            let valorEntrada = 0;
            let setupEnt = 0;

           //dados do pedido
            let _pedido = {
                PedId: 0,
                GrtId: 0,
                CdtId: 0,
                IdiId: 0,
                PedDataPedido: this.$moment({
                                year: this.$moment().year(),
                                month: dados.mesPrimeiroVencimento - 1, // moment usa mês 0-11
                                day: dados.diaVencimento,
                                hour: this.$moment().hour(),
                                minute: this.$moment().minute(),
                                second: this.$moment().second()
                                }).format('YYYY-MM-DDTHH:mm:ss'),
                PedOrigemPedido: this.selectedGarantidora.garNomeEmpresa,
                CliId: _endereco.cliId,
                ImobId: this.selectedImobiliaria.imoId,
                GarId: this.selectedGarantidora.garId,
                PedFormaPgto: 'Boleto Condomínio',
                PedTipoPgto: "3",
                PedValorParcelas: valorParcelas,
                PedQtdeParcelas: qtdeParcelas,
                PedObsLoja: '',
                PedRetornoPgto: 'pending',
                PedCodigoRetornoPgto: '',
                PspId: _pspId,
                PedSituacaoPedido: _situacao,
                PedObsCliente: '',
                PedUser: this.User.cusid,
                PedValorEntrada: valorEntrada,
                PedSetupEntrada: setupEnt == 1 ? true : false
            }
            // console.log('_pedido')
            // console.log(_pedido)

            await axios.post(`/Telas/TombamentoContratacao/AddPedidos`, _pedido)
                .then(response => {
                    if (response.data > 0) {
                        _pedido.PedId = response.data;
                        this.NumeroPedido = _pedido.PedId;
                        console.log('_pedido adicionado')
                        // console.log(_pedido)                
                    }
                });

            console.log('dados')
            console.log(dados)

            //itens do pedido
            let _pedidoItens = [];
                _pedidoItens.push(
                    {
                        PdiId: 0,
                        GrtId: 0,
                        CdtId: 0,
                        IdiId: 0,
                        PedId: _pedido.PedId,
                        ProId: dados.residencialComercial == 'Residencial' ? 1 : 2,
                        PdiNomeProduto: dados.residencialComercial == 'Residencial' ? 'Garantia Residencial' : 'Garantia Comercial',
                        PdiQtdeProduto: 1,
                        PdiValorProduto: valorTotalFinal,
                        PdiValorTotalProduto: valorTotalFinal,
                        PdiDataCadastro: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
                        PdiDataVigenciaIni: this.$moment(dados.dataVigenciaIni).format('YYYY-MM-DD'),
                        PdiDataVigenciaFim: this.$moment(dados.dataVigenciaFim).format('YYYY-MM-DD'),
                        PdiCampoExtra1: '0',
                        PdiCampoExtra2: '0',
                        Grid: [],
                    }
            );


             //pedido Endereço
            let _pedidoEndereco = {
                PdcId: 0,
                GrtId: 0,
                CdtId: 0,
                IdiId: 0,
                PdcEndereco: _endereco.cleEndereco,
                PdcNumero: _endereco.cleNumero,
                PdcComplemento: _endereco.cleComplemento,
                PdcObsEndereco: '',
                pdcCep: _endereco.cleCep,
                PdcPais: 'Brasil',
                PdcEstado: _endereco.cleEstado,
                PdcCidade: _endereco.cleCidade,
                PdcBairro: _endereco.cleBairro,
                PedId: _pedido.PedId,
                PdcTipo: dados.residencialComercial,
                PdcResidencialTipo: dados.apartamentoCasa,
            }

            await axios.post(`/Telas/TombamentoContratacao/AddPedidoEndereco`, _pedidoEndereco)
                .then(response => {
                    if (response.data > 0) {
                        console.log('_pedidoEndereco adicionado')
                        //console.log(_pedidoEndereco)                
                    }
                });

            const parseBR = str => {
                if (typeof str !== 'string') return 0;
                const cleaned = str.replace(/\./g, '').replace(/,/g, '.').trim();
                const num = parseFloat(cleaned);
                return isNaN(num) ? 0 : num;
            };

            for (const itens of _pedidoItens) {
                try {
                    // 1) Insere o item principal
                    const { data: newId } = await axios.post(
                        `/Telas/TombamentoContratacao/AddPedidoItem`,
                        itens
                    );

                }
                catch (err) {
                    console.error('Erro ao processar itens do pedido:', err);
                }
            }

            /* let _pedidoitemadicional = {
                        PiaId: 0,
                        GrtId: 0,
                        CdtId: 0,
                        IdiId: 0,
                        PedId: _pedido.PedId,
                        PiaNomeProduto: 'Aluguel (Mensal)',
                        PiaQtdeProduto: 1,
                        PiaValorProduto: valorTotalFinal,
                        PiaValorTotalProduto: valorTotalFinal,
                        PiaDataCadastro: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
                        PiaCampoExtra1: ''
                }*/



            let _dadosSituacao = {
                PspId: 3,
                PedSituacaoPedido: "Vigente",
                PedRetornoPgto: "Pending Pgto",
                PedInvoiceId: "",
                PedCodigoRetornoPgto: "",
                PedQtdeParcelas: qtdeParcelas,
                PedValorParcelas: valorParcelas,
                PedTipoPgto: "3",
                PedValorEntrada: valorEntrada,
                PedSetupEntrada: setupEnt == 1 ? true : false,
                PedObsAnalise: "Aprovado Sistemicamente (Tombamento).",
                PedId: _pedido.PedId,
            }

           await axios.put(`/Telas/TombamentoContratacao/UpdateSituacaoPgtoPedidos`, _dadosSituacao)
                .then(response => {
                    if (response.status == 200) {
                        console.log('Update Situacao')
                    }
            });
        },
        formatarDataExcel(data) {
            if (!data && data !== 0) return null;

            let d;

            // 1) Se for número => serial do Excel
            if (typeof data === "number") {
                // Usa o parser interno da lib XLSX (corrige bug do Excel e não sofre com fuso)
                const dc = XLSX.SSF.parse_date_code(data);
                if (!dc) return null;

                // Monta uma data "pura" (ano, mês, dia) sem mexer em timezone
                d = moment({
                    year: dc.y,
                    month: dc.m - 1, // moment usa 0–11
                    day: dc.d
                });
            }
            // 2) Se já vier como Date
            else if (data instanceof Date) {
                d = moment(data);
            }
            // 3) Se vier string "DD/MM/YYYY"
            else if (typeof data === "string") {
                d = moment(data, "DD/MM/YYYY", true);
            } else {
                return null;
            }

            if (!d.isValid()) return null;

            // Formato final: "YYYY-MM-DD HH:mm:ss.000"
            return d.format("YYYY-MM-DD 00:00:00.000");
            // ou: return d.format("YYYY-MM-DD HH:mm:ss.000") se quiser hora variável
        },
        getExcelField(row, ...keys) {
            for (const key of keys) {
                if (row[key] !== undefined && row[key] !== null) {
                    return row[key];
                }
            }

            const normalized = Object.keys(row).reduce((acc, currentKey) => {
                if (currentKey == null) return acc;
                acc[currentKey.toString().trim().toLowerCase()] = row[currentKey];
                return acc;
            }, {});

            for (const key of keys) {
                const normalizedKey = key.toString().trim().toLowerCase();
                if (normalized[normalizedKey] !== undefined && normalized[normalizedKey] !== null) {
                    return normalized[normalizedKey];
                }
            }

            return null;
        },
        async CarregaExcelMemoria() {
            if (!this.selectedFile) {
                this.$mensagemAviso?.("Selecione um arquivo XLSX primeiro.");
                return;
            }

            if (this.selectedGarantidora == '' || this.selectedGarantidora == null) {
                this.$mensagemAviso("Selecione Garantidora.");
                return;
            }

            if (this.selectedImobiliaria == '' || this.selectedImobiliaria == null) {
                this.$mensagemAviso("Selecione Imobiliaria.");
                return;
            }

            if (!Number.isFinite(Number(this.coberturaQtdeVezes)) || Number(this.coberturaQtdeVezes) <= 0) {
                this.$mensagemAviso('Informe uma quantidade de vezes da cobertura maior que zero.');
                return;
            }

            try {
                this.startLoading();
                await axios.get(`/Telas/TombamentoContratacao/ValidarPreRequisitos/${this.selectedGarantidora.garId}/${this.selectedImobiliaria.imoId}`);
            } catch (error) {
                const mensagem = error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Não foi possível validar garantidora e imobiliária.';
                this.$mensagemErro(mensagem);
                return;
            } finally {
                this.stopLoading();
            }

            // v-file-input pode retornar um File ou um array de File (dependendo da prop multiple)
            const file = Array.isArray(this.selectedFile)
                ? this.selectedFile[0]
                : this.selectedFile;

            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });

                    // Primeira planilha
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    if (!worksheet) throw new Error('A planilha não possui uma aba válida.');

                // Converte usando a primeira linha como cabeçalho (usa exatamente os nomes das colunas)
                    const linhas = XLSX.utils.sheet_to_json(worksheet, {
                        defval: null,
                        raw: true // mantém o serial numérico das datas
                    });

                // Mapeia para o formato que você quiser usar na tela
                    this.ListaPedidoItem = linhas.map((l) => ({
                    documentoCPFCNPJ: this.getExcelField(l, 'DocumentoCPFCNPJ', 'documentoCPFCNPJ', 'Documento', 'CPFcnpj'),
                    nome: this.getExcelField(l, 'Nome', 'nome'),
                    whatsapp: this.getExcelField(l, 'Whatsapp', 'whatsapp', 'WhatsApp'),
                    responsavel: this.getExcelField(l, 'Responsavel', 'responsavel'),
                    responsavelCPF: this.getExcelField(l, 'responsavelCPF', 'ResponsavelCPF'),
                    email: this.getExcelField(l, 'Email', 'email', 'E-mail'),
                    nomePai: this.getExcelField(l, 'NomePai', 'nomePai'),
                    nomeMae: this.getExcelField(l, 'NomeMae', 'nomeMae'),
                    residencialComercial: this.getExcelField(l, 'ResidencialComercial', 'residencialComercial'),
                    apartamentoCasa: this.getExcelField(l, 'ApartamentoCasa', 'apartamentoCasa'),
                    endRua: this.getExcelField(l, 'EndRua', 'endRua', 'Rua'),
                    endNumero: this.getExcelField(l, 'EndNumero', 'endNumero', 'Numero', 'Número'),
                    endComplemento: this.getExcelField(l, 'EndComplemento', 'endComplemento'),
                    endCEP: this.getExcelField(l, 'EndCEP', 'endCEP', 'CEP'),
                    endEstado: this.getExcelField(l, 'EndEstado', 'endEstado', 'Estado'),
                    endCidade: this.getExcelField(l, 'EndCidade', 'endCidade', 'Cidade'),
                    endBairro: this.getExcelField(l, 'EndBairro', 'endBairro', 'Bairro'),

                    dataVigenciaIni: this.formatarDataExcel(this.getExcelField(l, 'DataVigenciaIni', 'dataVigenciaIni', 'DataVigencia', 'Data Inicio')),
                    dataVigenciaFim: this.formatarDataExcel(this.getExcelField(l, 'DataVigenciaFim', 'dataVigenciaFim', 'DataVigenciaFim', 'Data Fim')),

                    qtdeParcelas: this.getExcelField(l, 'QtdeParcelas', 'qtdeParcelas', 'QuantidadeParcelas', 'QtdParcelas'),
                    valorParcelas: this.getExcelField(l, 'ValorParcelas', 'valorParcelas', 'ValorParcela', 'Valor Parcela', 'Valor', 'valor'),
                    mesPrimeiroVencimento: this.getExcelField(l, 'MesPrimeiroVencimento', 'mesPrimeiroVencimento', 'MesPrimeiroVencimento', 'MesPrimeiroVencimento'),
                    diaVencimento: this.getExcelField(l, 'DiaVencimento', 'diaVencimento', 'DiaVencimento', 'Vencimento')
                    }));
                    this.ProcessarImportacao();
                } catch (error) {
                    console.error('[GarantePay] Falha ao interpretar a planilha.', error);
                    this.ListaPedidoItem = [];
                    this.$mensagemErro(error?.message || 'Não foi possível ler a planilha selecionada.');
                }
            };

            reader.onerror = () => {
                console.error('[GarantePay] Falha ao ler o arquivo selecionado.', reader.error);
                this.$mensagemErro('Não foi possível ler o arquivo selecionado. Verifique o arquivo e tente novamente.');
            };

            reader.readAsArrayBuffer(file);
        },
        sanitizarItem(item) {
            const camposTexto = [
            "documentoCPFCNPJ",
            "nome",
            "whatsapp",
            "responsavel",
            "responsavelCPF",
            "email",
            "nomePai",
            "nomeMae",
            "residencialComercial",
            "apartamentoCasa",
            "endRua",
            "endComplemento",
            "endEstado",
            "endCidade",
            "endBairro"
            ];

            // Trim e remove espaços duplos
            camposTexto.forEach((c) => {
            if (item[c] !== null && item[c] !== undefined) {
                item[c] = String(item[c]).trim().replace(/\s+/g, " ");
            }
            });

            // Documento e CEP só números
            if (item.documentoCPFCNPJ) {
            item.documentoCPFCNPJ = item.documentoCPFCNPJ.replace(/\D/g, "");
            }
            if (item.endCEP) {
            item.endCEP = String(item.endCEP).replace(/\D/g, "");
            }

            // Estado em maiúsculo
            if (item.endEstado) {
            item.endEstado = String(item.endEstado).trim().toUpperCase();
            }

            // Número do endereço como número (se possível)
            if (item.endNumero !== null && item.endNumero !== undefined && item.endNumero !== "") {
            const n = Number(item.endNumero);
            item.endNumero = isNaN(n) ? item.endNumero : n;
            }

            // Valores numéricos
            if (item.valorParcelas !== null && item.valorParcelas !== undefined && item.valorParcelas !== "") {
            const valorTexto = String(item.valorParcelas).trim();
            item.valorParcelas = Number(valorTexto.includes(',') ? valorTexto.replace(/\./g, '').replace(',', '.') : valorTexto);
            }
            if (item.qtdeParcelas !== null && item.qtdeParcelas !== undefined && item.qtdeParcelas !== "") {
            item.qtdeParcelas = Number(item.qtdeParcelas);
            }
            if (item.mesPrimeiroVencimento !== null && item.mesPrimeiroVencimento !== undefined && item.mesPrimeiroVencimento !== "") {
            item.mesPrimeiroVencimento = Number(item.mesPrimeiroVencimento);
            }
            if (item.diaVencimento !== null && item.diaVencimento !== undefined && item.diaVencimento !== "") {
            item.diaVencimento = Number(item.diaVencimento);
            }

            return item;
        },
        validarItem(item, index) {
            const erros = [];

            const linhaExcel = index + 2; // +2 por causa do cabeçalho (linha 1)
            console.log(item)
            // Campos obrigatórios (não podem ser vazios)
            const obrigatorios = [
            "documentoCPFCNPJ",
            "nome",
            "whatsapp",
            "email",
            "residencialComercial",
            "apartamentoCasa",
            "endRua",
            "endNumero",
            "endEstado",
            "endCidade",
            "endBairro",
            "dataVigenciaIni",
            "dataVigenciaFim",
            "qtdeParcelas",
            "valorParcelas",
            "mesPrimeiroVencimento",
            "diaVencimento"
            ];

            obrigatorios.forEach((campo) => {
            if (
                item[campo] === null ||
                item[campo] === undefined ||
                item[campo] === ""
            ) {
                erros.push(`Linha ${linhaExcel}: campo "${campo}" é obrigatório.`);
            }
            });

            // Documento: CPF ou CNPJ (11 ou 14 dígitos)
            if (item.documentoCPFCNPJ && !/^(\d{11}|\d{14})$/.test(item.documentoCPFCNPJ)) {
            erros.push(`Linha ${linhaExcel}: DocumentoCPFCNPJ deve ter 11 (CPF) ou 14 (CNPJ) dígitos numéricos.`);
            }

            if (item.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.email)) {
            erros.push(`Linha ${linhaExcel}: E-mail inválido.`);
            }

            // Estado: no máximo 2 caracteres (UF)
            if (item.endEstado) {
            if (item.endEstado.length > 2) {
                erros.push(`Linha ${linhaExcel}: EndEstado deve ser a UF com 2 letras (ex: "RS", "SP"). Valor atual: "${item.endEstado}".`);
            }
            }

            // CEP: 8 dígitos
            if (item.endCEP && !/^\d{8}$/.test(item.endCEP)) {
            erros.push(`Linha ${linhaExcel}: CEP deve ter 8 dígitos numéricos (sem traço). Valor atual: "${item.endCEP}".`);
            }

            // Números
            if (item.valorParcelas !== null && (!Number.isFinite(item.valorParcelas) || item.valorParcelas <= 0)) {
            erros.push(`Linha ${linhaExcel}: ValorParcelas deve ser maior que zero.`);
            }
            if (!Number.isInteger(item.qtdeParcelas) || item.qtdeParcelas <= 0) {
            erros.push(`Linha ${linhaExcel}: QtdeParcelas deve ser um inteiro maior que zero.`);
            }
            if (!Number.isInteger(item.mesPrimeiroVencimento) || item.mesPrimeiroVencimento < 1 || item.mesPrimeiroVencimento > 12) {
            erros.push(`Linha ${linhaExcel}: MesPrimeiroVencimento deve ser um número entre 1 e 12.`);
            }
            if (!Number.isInteger(item.diaVencimento) || item.diaVencimento < 1 || item.diaVencimento > 31) {
            erros.push(`Linha ${linhaExcel}: DiaVencimento deve ser um número entre 1 e 31.`);
            }

            // Datas: formato "YYYY-MM-DD HH:mm:ss.000"
            const dtIni = moment(item.dataVigenciaIni, "YYYY-MM-DD HH:mm:ss.SSS", true);
            const dtFim = moment(item.dataVigenciaFim, "YYYY-MM-DD HH:mm:ss.SSS", true);

            if (!dtIni.isValid()) {
            erros.push(`Linha ${linhaExcel}: DataVigenciaIni em formato inválido. Valor: "${item.dataVigenciaIni}".`);
            }
            if (!dtFim.isValid()) {
            erros.push(`Linha ${linhaExcel}: DataVigenciaFim em formato inválido. Valor: "${item.dataVigenciaFim}".`);
            }
            if (dtIni.isValid() && dtFim.isValid() && dtFim.isBefore(dtIni)) {
            erros.push(`Linha ${linhaExcel}: DataVigenciaFim não pode ser menor que DataVigenciaIni.`);
            }

            // Campos que PODEM ser nulos: nomePai, nomeMae, responsavel, responsavelCPF -> então não precisa validar

            return erros;
        },
        async validarListaPedidoItem() {
            const errosGerais = [];

            // 1) Sanitizar tudo
            this.ListaPedidoItem = this.ListaPedidoItem.map((it) =>
            this.sanitizarItem({ ...it })
            );

            // 2) Validar linha a linha
            this.ListaPedidoItem.forEach((item, index) => {
            const errosLinha = this.validarItem(item, index);
            errosGerais.push(...errosLinha);
            });

            const chaves = new Map();
            this.ListaPedidoItem.forEach((item, index) => {
                const normalizar = (valor) => String(valor ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                const chave = [item.documentoCPFCNPJ, item.endRua, item.endNumero, item.endComplemento,
                    item.endCEP, item.endBairro, item.endCidade, item.endEstado].map(normalizar).join('|');
                if (chaves.has(chave)) {
                    errosGerais.push(`Linha ${index + 2}: documento e endereço repetem a linha ${chaves.get(chave)} da planilha.`);
                } else {
                    chaves.set(chave, index + 2);
                }
            });

            if (errosGerais.length > 0) {
            // Você pode tratar como quiser: exibir no console, modal, etc.
            console.error("Erros na importação do Excel:", errosGerais);

            // Se tiver seu método de mensagem:
            if (this.$mensagemAviso) {
                this.$mensagemAviso(
                `Foram encontrados ${errosGerais.length} problema(s) no arquivo. Verifique o console para detalhes.`
                );
            }

            this.ListaErros = errosGerais;

            return {
                valido: false,
                erros: errosGerais
            };
            }

            return {
            valido: true,
            erros: []
            };
        },
        async ProcessarImportacao() {
            this.ListaErros = [];
            this.ResultadosImportacao = [];
            const resultadoValidacao = await this.validarListaPedidoItem();
            if (!resultadoValidacao.valido) return;

            this.startLoading();
            const total = this.ListaPedidoItem.length;
            try {
                for (let index = 0; index < total; index++) {
                    const item = this.ListaPedidoItem[index];
                    this.progressoImportacao = `Processando ${index + 1} de ${total}`;
                    try {
                        const response = await axios.post('/Telas/TombamentoContratacao/ImportarLinha', {
                            garId: this.selectedGarantidora.garId,
                            imoId: this.selectedImobiliaria.imoId,
                            garantidoraNome: this.selectedGarantidora.garNomeEmpresa,
                            documentoCpfCnpj: item.documentoCPFCNPJ,
                            nome: item.nome,
                            whatsapp: item.whatsapp,
                            responsavel: item.responsavel,
                            email: item.email,
                            nomePai: item.nomePai,
                            nomeMae: item.nomeMae,
                            residencialComercial: item.residencialComercial,
                            apartamentoCasa: item.apartamentoCasa,
                            endRua: item.endRua,
                            endNumero: String(item.endNumero),
                            endComplemento: item.endComplemento,
                            endCep: item.endCEP,
                            endEstado: item.endEstado,
                            endCidade: item.endCidade,
                            endBairro: item.endBairro,
                            dataVigenciaIni: item.dataVigenciaIni,
                            dataVigenciaFim: item.dataVigenciaFim,
                            qtdeParcelas: item.qtdeParcelas,
                            valorParcelas: item.valorParcelas,
                            mesPrimeiroVencimento: item.mesPrimeiroVencimento,
                            diaVencimento: item.diaVencimento,
                            coberturaQtdeVezes: Number(this.coberturaQtdeVezes),
                            gerarContrato: this.gerarContrato
                        });
                        this.ResultadosImportacao.push({
                            linha: index + 2,
                            sucesso: true,
                            aviso: response.data.avisoContrato === true,
                            mensagem: response.data.mensagem || `Contratação ${response.data.pedId} importada.`
                        });
                    } catch (error) {
                        const mensagem = error?.response?.data?.message || error?.response?.data?.Message || error?.message || 'Falha não identificada.';
                        this.ResultadosImportacao.push({ linha: index + 2, sucesso: false, mensagem });
                    }
                }
                const sucessos = this.ResultadosImportacao.filter(x => x.sucesso).length;
                const falhas = total - sucessos;
                const avisos = this.ResultadosImportacao.filter(x => x.aviso).length;
                this.progressoImportacao = `${sucessos} importada(s), ${falhas} não importada(s)${avisos ? ` e ${avisos} contrato(s) pendente(s)` : ''}.`;
                if (falhas === 0 && avisos === 0) this.$mensagemSucesso?.('Importação concluída com sucesso.');
                else this.$mensagemAviso?.('Importação concluída com pendências. Consulte o resultado por linha.');
            } finally {
                this.stopLoading();
            }
        }
    },
    async created() {
        await axios.get(`/Telas/TombamentoContratacao/GetDados`)
            .then(response => {
                this.User.garid = response.data.garId;
                this.User.tpeid = response.data.tpeId;
                this.User.pesid = response.data.pesId;
                this.User.cusid = response.data.cusId;
                this.DadosGarantidora = response.data.garantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                this.DadosImobiliaria = response.data.imobiliarias.filter(x => x.imoVisivel).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
            });
    },
}
</script>

<style scoped>
.gp-import-summary {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin: 8px 0;
    padding: 10px 12px;
    border-radius: 9px;
    background: #f4f7fb;
    color: #102a5a;
}

.gp-import-result {
    margin-top: 6px;
    padding: 8px 10px;
    border-left: 3px solid;
    border-radius: 7px;
    font-size: 11px;
}

.gp-import-result.is-success { background: #eefaf5; border-color: #198754; }
.gp-import-result.is-warning { background: #fff8e8; border-color: #e98a00; }
.gp-import-result.is-error { background: #fff1f1; border-color: #dc3545; }
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    border: 1px solid #333333;
    padding: 3px;
}

.small-text {
    font-size: 10px;
    color: #dc2626;
    margin-top: 0px !important;
    position: absolute;
}


@media (min-width:1200px) {

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */

    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }

    .controlcelEnd {
        height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

@media (min-width:768px) {
    .altavul {
        padding-top: 35px;
    }

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }
}


@media (max-width:767px) {

    .fonttext {
        font-size: 12px;
    }

    .altcel {
        min-height: 300px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 5px;
    }

    .text-h5 {
        font-size: 15px !important;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        padding: 0 !important;
        font-size: 12px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 12px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .v-toolbar-title__placeholder {
        overflow: auto;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .v-toolbar-title {
        flex: auto !important;
        font-size: 1.25rem;
        min-width: 0;
        font-size: 1.25rem;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 1.75rem;
        text-transform: none;
    }

}

.border-green {
    border: 4px solid green !important;
    /* Defina a cor e largura da borda */
    border-radius: 8px;
    /* Adicione um raio de borda para suavizar a aparência */
}

.check-icon {
    position: absolute;
    bottom: 5px;
    /* Ajuste conforme necessário */
    right: 5px;
    /* Ajuste conforme necessário */
    color: green;
    background-color: white;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    /* Adiciona sombra para destaque */
}
</style>
